export const STRATEGY_SSO_LOGIN_COMPULSORY = true;

export const STRATEGY_ONLY_NUXEO = true;

export const STRATEGY_WITH_HIERARCHY = false;
